export default "__VITE_ASSET__CpFXR3aL__"